import React from 'react';
import { getProfileName } from './Instagram.utils';
import OutboundLink from '../../../../../../atoms/OutboundLink';
import './Instagram.css';
export default function Photo(_ref) {
  var url = _ref.url;
  if (!url) {
    return null;
  }
  var profileName = getProfileName(url);
  return /*#__PURE__*/React.createElement("div", {
    className: "instagram-container"
  }, /*#__PURE__*/React.createElement(OutboundLink, {
    to: url,
    label: profileName
  }));
}